// extracted by mini-css-extract-plugin
export default {"body":"ExceptionTransactionsTable_body__hXOtL","summary":"ExceptionTransactionsTable_summary__vOlSF"};